import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Typography,
  MenuItem
} from "@mui/material";
import { authenticationService } from "src/services";
import { get, put } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

/* =========================
   Props
========================= */
interface UpdateAreaProps {
  handleClose: () => void;
  fetchAreas: () => void;
  areaidvalues: any;
}
interface CityDropdown {
  id: number;
  city: string;
}
const UpdateArea: React.FC<UpdateAreaProps> = ({
  handleClose,
  fetchAreas,
  areaidvalues
}) => {
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { showSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [cities, setCitiesList] = useState<CityDropdown[]>([]);

  const [form, setForm] = useState({
    id: 0,
    name: "",
    cityId: "",
    zipCode: "",
    isActive: true,
    vendorId: vendorId
  });

  /* =========================
       Fetch Cities (GET)
    ========================= */
    const fetchCities = async () => {
      try {
        const response = await get(`${APIURL}/api/miscellaneous/city/vendor/${vendorId}/findAll`);
        console.log('response',response)
        if (response) setCitiesList(response?.data);
      } catch (error) {
        console.error("Error fetching states", error);
      }
    };
  
    useEffect(() => {
      fetchCities();
    }, []);

  /* =========================
     Prefill Area Data
  ========================= */
  useEffect(() => {
    if (areaidvalues) {
      setForm({
        id: areaidvalues.id,
        name: areaidvalues.name || "",
        cityId: areaidvalues.cityId || "",
        zipCode: areaidvalues.zipCode || "",
        isActive: areaidvalues.isActive,
        vendorId: vendorId
      });
    }
  }, [areaidvalues, vendorId]);

  /* =========================
     Handlers
  ========================= */
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.name) {
      showSnackbar("Area name  required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        id: form.id,
        name: form.name,
        cityId: form.cityId,
        zipCode: form.zipCode,
        isActive: form.isActive,
        vendorId: form.vendorId
      };

      const response = await put(
        `${APIURL}/api/miscellaneous/area`,
        payload
      );

      if (response?.statusCode === 200) {
        showSnackbar(
          response?.message || "Area updated successfully",
          "success"
        );
        fetchAreas();
        handleClose();
      } else {
        showSnackbar(
          response?.message || "Failed to update area",
          "error"
        );
      }
    } catch (error: any) {
      showSnackbar(error?.message || "Failed to update area", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Update Area
      </Typography>

      <Grid container spacing={2}>

        {/* City Dropdown */}
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            required
            label="City"
            name="cityId"
            value={form.cityId}
            onChange={handleChange}
          >
            {cities.map(city => (
              <MenuItem key={city.id} value={city.id}>
                {city.city}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Area Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>

        

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={e =>
                  setForm(prev => ({
                    ...prev,
                    isActive: e.target.checked
                  }))
                }
              />
            }
            label="Is Active"
          />
        </Grid>

        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdateArea;
